import { ReactComponent as MailIcon } from 'assets/icons/mail.svg'

import { Button } from './uikit/button/Button'

export const HelpBanner = () => {
  return (
    <div className="mx-auto w-[1120px] bg-gradient-to-r from-[#C9252B] via-[#F79900] to-[#6AC9CE] rounded-[24px] flex items-center justify-center p-[3px]">
      <div className="w-full h-full rounded-[20px] flex gap-4 p-8  bg-white items-center">
        <MailIcon className=" shrink-0" />
        <strong className="font-bold text-18 leading-7 shrink-0">Need help?</strong>
        <span className="leading-[22px] text-14 grow">
          Can’t find what you need in the FAQ? No worries—just reach out, and we’ll get you sorted!
        </span>
        <Button
          className="shrink-0"
          variant="primary"
          onClick={() => window.open('mailto:networkedmarketingawards@coca-cola.com')}
          text="Contact Us"
        />
      </div>
    </div>
  )
}
